import React, { useCallback, useEffect, useRef, useState } from "react";
import useInput from "../../../hooks/useInput";
import { useAppDispatch } from "../../../store";
import { Navigate } from "react-router-dom";
import { useNavigate, createSearchParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducer/index";
import { Farmstype } from "../../../reducer/postpayloadtypes";
import styled from "styled-components";
import { SelectOptionType } from "../../../FrontType/index";
import postSlice from "../../../reducer/post";
import InsectName from "./component/InsectName";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
`;

const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 40px;
  width: 100%;
  .move-btn {
    width: 30px;
    & img {
      width: 100%;
    }
  }
  .pagetit {
    font-size: 1.13em;
    font-family: "spoqa500";
    margin-left: 10px;
  }

  @media screen and (min-width: 1050px) {
    font-size: 1.4em;
    p {
      & img {
        width: 30%;
      }
    }
  }
`;

const SelectInsect = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;
const InsectItem = styled.div`
  width: 20%;
  margin-left: 5vw;
  margin-top: 51px;
  :first-child {
    margin-left: 0;
  }

  img {
    width: 100%;
    border-radius: 50%;
    border: 1px solid #d8d7d7;
    background-color: #dddddd !important;
    cursor: pointer;
  }
  p {
    text-align: center;
    font-size: 1.5vw;
    font-family: "Spoqa700";
  }
`;

const ModalCon = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  border: 1px solid gold;
  z-index: 999;

  div {
    box-shadow: -1px 1px 8px 4px #fff;
    width: 60%;
    height: 500px;
    display: flex;
    align-items: center;
    /* justify-content: flex-start; */
    justify-content: center;
    flex-wrap: wrap;
    font-size: 2vw;
    opacity: 1;
    position: absolute;
    background-color: #fff;
  }
  div img {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    cursor: pointer;
  }
  div p {
    width: 45%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    margin-left: 20px;
    box-shadow: 0px 1px 10px 0px #564a4a;
  }
`;

const SelectBtn = styled.div`
  background-color: rgba(247, 247, 247, 1);
  /* box-shadow: rgba(0, 0, 0, 0.25); */
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  /* width: 163px; */
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  p {
    font-size: 20px;
  }
`;
const PostSelectInsect = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { Farms, Targetfarms, Diarylist } = useSelector(
    (state: RootState) => state.post
  );

  const location = useLocation();

  let [arrow, setarrow] = useState(true);
  const emptyOption = { value: "WHOLE", label: "전체" };
  const [selectedInsect, setSelectedInsect] =
    useState<SelectOptionType>(emptyOption);
  const [selectedDiaryType, setSelectedDiaryType] =
    useState<SelectOptionType | null>();
  const [startdate, setStartdate] = useState<string>("");
  const [enddate, setEnddate] = useState<string>("");
  const [modal, setModal] = useState(false);
  const [container, setContainer] = useState<Farmstype[] | undefined>([]);

  const [isArrow, setIsArrow] = useState<string>("");
  const [id1, setId1] = useState<string>("");
  const [id2, setId2] = useState<string>("");
  const [id3, setId3] = useState<string>("");
  const [id4, setId4] = useState<string>("");
  const [id5, setId5] = useState<string>("");

  // let products: string[] = [];
  // Targetfarms?.children.map((v) => {
  //   products.push(v.productCode);
  // });

  let [place, setPlace] = useState<
    { name: string; placeId: number; insectName: string }[]
  >([]);
  // const flterproduct: string[] = products.filter((element, index) => {
  //   return products.indexOf(element) === index;
  // });

  let [insectcon, setinsectcon] = useState<{ key: string; name: string }[]>([]);
  let [insectcode, setinscetcode] = useState<string[]>([]);

  let [selectedPlaceId, setSelectedPlaceId] = useState<number>(0);
  let [selectInsect, setSelectInsect] = useState<string>("");

  async function ModalInsect(
    insect: string,
    placeId: number,
    insectName: string
  ) {
    setModal(false);
    let modalitem: string[] = [];

    // 선택된 사육실
    let selectedPlaceId = 0;
    selectedPlaceId = placeId;
    setSelectedPlaceId(selectedPlaceId);

    console.log("selectedPlaceId :: ", selectedPlaceId);
    console.log("insect12345 :: ", insectName);

    try {
      const response = await axios.get(
        `/ifactory/api/place/insect/boxes?placeId=${selectedPlaceId}&type=CONTAINER`
      );
      // const response = await axios.get(`/ifactory/api/place`);
      const result = response.data;
      console.log("result", result);

      const keys = Object.keys(result);
      const newInsectNames = keys.map((key) => ({
        key: InsectName(key),
        name: key,
      }));
      const newInsectCode = keys.map((key) => key);

      console.log("newInsectNames :: ", newInsectNames);
      console.log("newInsectCode :: ", newInsectCode);

      setModal(true);
      setinsectcon(
        newInsectNames.map((item) => ({ key: item.key, name: item.name }))
      );

      setinscetcode(newInsectCode);

      // const items = result.map((item: any) => ({
      //   name: item.name,
      //   placeId: item.placeId
      // }));

      // setinsectcon(items);
      console.log("ModalInsect", response.data);
    } catch (error: any) {
      setModal(false);

      confirmAlert({
        title: error.response.data.message,
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }

    // Targetfarms?.children.map((item, idx) => {
    //   if (item.productCode === insect) {
    //     modalitem.push(item.name);
    //   }
    //   setinsectcon(modalitem);
    // });
  }

  // 사육실 불러오기
  useEffect(() => {
    const searchPlace = async () => {
      const targetdata = localStorage.getItem("targetfarm");
      try {
        const response = await axios.get(
          `/ifactory/api/place/specificplace?placeId=${Targetfarms?.placeId}`
        );
        // const response = await axios.get(`/ifactory/api/place`);
        const result = response.data;
        //console.log("result", result);
        const items = result.map((item: any) => ({
          name: item.name,
          placeId: item.placeId,
          insectName: item.insectName,
        }));

        setPlace(items);
        //console.log("searchPlace", response.data);
      } catch (error: any) {
        console.error(error);
      }
    };
    searchPlace();

    if (location.search || (location.state != null && location.state.isArrow)) {
      let isArrow = location.search
        ? location.search.split("&")[0].split("=")[1]
        : location.state.isArrow;
      let id1 = location.search
        ? location.search.split("&")[1].split("=")[1]
        : location.state.id1;
      let id2 = location.search
        ? location.search.split("&")[2].split("=")[1]
        : location.state.id2;
      let id3 = location.search
        ? location.search.split("&")[3].split("=")[1]
        : location.state.id3;
      let id4 = location.search
        ? location.search.split("&")[4].split("=")[1]
        : location.state.id4;
      let id5 = location.search
        ? location.search.split("&")[5].split("=")[1]
        : location.state.id5;

      if (isArrow !== "") setIsArrow(isArrow);
      if (id1 !== "") setId1(id1);
      if (id2 !== "") setId2(id2);
      if (id3 !== "") setId3(id3);
      if (id4 !== "") setId4(id4);
      if (id5 !== "") setId5(id5);
    }
  }, []);

  return (
    <Container>
      <PageTop>
        <p className="move-btn">
          <img
            src="./img/ArrowLeft.svg"
            onClick={() => {
              navigate("/MainPage", {
                state: {
                  isArrow: isArrow,
                  id1: id1,
                  id2: id2,
                  id3: id3,
                  id4: id4,
                  id5: id5,
                },
              });
            }}
          />
        </p>
        <p className="pagetit">사육실 선택</p>
      </PageTop>
      <SelectInsect>
        {place &&
          place.map((insect, idx) => {
            return (
              <InsectItem>
                <SelectBtn
                  // src="./img/silkworm_bgwhite.svg"
                  // src={InsectImage(insect)}
                  onClick={() => {
                    setModal(true);
                    ModalInsect(insect.name, insect.placeId, insect.insectName);
                  }}
                >
                  <p>{insect.name}</p>
                </SelectBtn>
              </InsectItem>
            );
          })}
      </SelectInsect>

      {modal === true ? (
        <ModalCon>
          <div>
            <img
              src="./img/X.svg"
              onClick={() => {
                setModal(false);
              }}
              alt="X"
            />
            {insectcon.map((InsectContainer: any, idx: number) => {
              return (
                <p
                  onClick={() => {
                    navigate("/PostDiaryPage", {
                      state: {
                        selectedPlaceId: selectedPlaceId,
                        selectedInsectCode: insectcode,
                        selectedInsectKey: InsectContainer,
                        isArrow: isArrow,
                        id1: id1,
                        id2: id2,
                        id3: id3,
                        id4: id4,
                        id5: id5,
                      },
                    });
                    dispatch(
                      postSlice.actions.TargetInsectContainer(InsectContainer)
                    );
                  }}
                >
                  {InsectContainer.key}
                </p>
              );
            })}
          </div>
        </ModalCon>
      ) : null}
    </Container>
  );
};

export default PostSelectInsect;
